import Vue from 'vue'
import vSelect from 'vue-select'
import menuBuilderStore from '../vue/stores/menubuilder.store';
 
export default {
  init() {
    Vue.component('v-select', vSelect)

    Vue.config.productionTip = false

    Vue.component('product-gallery', require('../vue/components/ProductGallery.vue').default)
    Vue.component('product-comparator', require('../vue/components/ProductComparator.vue').default)
    Vue.component('training-courses', require('../vue/components/TrainingCourses.vue').default)
    Vue.component('training-modules', require('../vue/components/TrainingModules.vue').default)
    Vue.component('multistep-form', require('../vue/components/MultiStepForm.vue').default)
    Vue.component('menu-builder', require('../vue/components/MenuBuilder/MenuBuilder.vue').default)

    Vue.prototype.$store = menuBuilderStore

    if(document.querySelectorAll("#vue-app").length) { 
      new Vue({}).$mount('#vue-app')
    }; 

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/common.js